import { INGREDIENT_PRESETS, } from '../../domain/index.js';
/** Helpers to write recipe templates and the blank recipe as data (drafts.md). */
export const H = 3600;
export const MIN = 60;
/** A dough ingredient with the composition of its preset (`formula/presets.ts`). */
export const preset = (id, bakerPct) => {
    const found = INGREDIENT_PRESETS.find((p) => p.id === id);
    if (!found)
        throw new Error(`unknown ingredient preset ${id}`);
    return { id, bakerPct, ...found.ingredient };
};
/** An `asap` step after `after` (none for the first), with its planned duration. */
export const step = (id, operation, after, durationS, options = {}) => ({
    id,
    operation,
    dependsOn: after,
    schedule: 'asap',
    plannedDurationS: durationS,
    ...(options.conditions ? { conditions: options.conditions } : {}),
    ...(options.label ? { label: options.label } : {}),
    ...(options.technique ? { technique: options.technique } : {}),
});
/** An `alap` step (preheating): as late as possible before its successors. */
export const alapStep = (id, operation, durationS) => ({
    id,
    operation,
    dependsOn: [],
    schedule: 'alap',
    plannedDurationS: durationS,
});
//# sourceMappingURL=build.js.map